"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDocumentEntity = void 0;
const CustomerDocumentDto_1 = require("./CustomerDocumentDto");
const CustomerProfileDto_1 = require("../customer-profiles/CustomerProfileDto");
const CustomerProfileEntity_1 = require("../customer-profiles/CustomerProfileEntity");
const BadRequestError_1 = require("../GS/BadRequestError");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const validators_1 = require("../GS/validators");
class CustomerDocumentEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, customerDocument) {
        super();
        this._requiredFieldsSetStatus = {
            customerProfileId: false,
            name: false,
            fileUrl: false,
            vin: false
        };
        this._dependencies = dependencies;
        if (customerDocument === undefined) {
            this._dto = new CustomerDocumentDto_1.CustomerDocumentDto();
        }
        else if (customerDocument instanceof CustomerDocumentDto_1.CustomerDocumentDto) {
            this._dto = new CustomerDocumentDto_1.CustomerDocumentDto(customerDocument);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (customerDocument instanceof CustomerDocumentEntity) {
            this._dto = new CustomerDocumentDto_1.CustomerDocumentDto(customerDocument._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new CustomerDocumentDto_1.CustomerDocumentDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getCustomerProfile() {
        if (this._dto.customerProfileId === undefined) {
            return undefined;
        }
        if (this._dto.customerProfile === undefined) {
            throw new Error("Cannot call getCustomerProfile without " +
                "first loading the CustomerProfile.");
        }
        if (!this._customerProfileEntity && this._dto.customerProfile) {
            this._customerProfileEntity = new CustomerProfileEntity_1.CustomerProfileEntity(this._dependencies, this._dto.customerProfile);
        }
        return this._customerProfileEntity;
    }
    getCustomerProfileId() {
        return this._dto.customerProfileId;
    }
    setCustomerProfile(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof CustomerProfileEntity_1.CustomerProfileEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof CustomerProfileDto_1.CustomerProfileDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setCustomerProfileId(untrustedId);
        if (this.hasError("customerProfileId")) {
            return;
        }
        if (untrustedValue instanceof CustomerProfileEntity_1.CustomerProfileEntity) {
            this._customerProfileEntity = untrustedValue;
        }
    }
    setCustomerProfileId(untrustedValue) {
        let _untrustedValue;
        this.clearError("customerProfileId");
        this._requiredFieldsSetStatus.customerProfileId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("customerProfileId", "Customer Profile Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("customerProfileId", "Customer Profile is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.customerProfileId) {
            return;
        }
        this._dto.customerProfileId = _untrustedValue;
        delete this._customerProfileEntity;
        this._setIsDirty(true);
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getFileUrl() {
        return this._dto.fileUrl;
    }
    setFileUrl(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("fileUrl");
        this._requiredFieldsSetStatus.fileUrl = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("fileUrl", "File URL is required."));
        }
        else if (!validators_1.isUrl(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("fileUrl", "File URL is invalid."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("fileUrl", `File URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.fileUrl) {
            return;
        }
        this._dto.fileUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getVin() {
        return this._dto.vin;
    }
    loadCustomerProfileAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getCustomerProfileId()) {
                    return;
                }
                this._emit("before-loadCustomerProfileAsync");
                this._dto.customerProfile =
                    yield this._dependencies.customerProfileDatastore
                        .getAsync(this.getCustomerProfileId(), expand);
                delete this._customerProfileEntity;
                this._emit("after-loadCustomerProfileAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.customerDocumentDatastore
                    .getAsync(id, expand);
                delete this._customerProfileEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Customer Document is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.customerDocumentDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.customerDocumentDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Customer Document cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.customerDocumentDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.CustomerDocumentEntity = CustomerDocumentEntity;
//# sourceMappingURL=CustomerDocumentEntity.js.map